import { ActionCard } from "@/organisms/Drawers/components/TriageDrawer/components/ActionsCard"

import type { getProjectsTriageSelector } from "@/pages/TriagePage/application/useTriage.selector"

export const TriageActionCell = (
  _: string,
  record: ReturnType<typeof getProjectsTriageSelector>["data"][number]
): React.ReactNode => (
  <ActionCard.Label
    hasTicketAction={record.hasTicketAction}
    ticketSystems={record.ticketSystems}
    hasPullRequestAction={record.hasPullRequestAction}
  />
)
